import { useEffect, useState, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";

import { Loader } from "@/components/site/Loader";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Gallery } from "@/components/site/Gallery";
import { Packages } from "@/components/site/Packages";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Process } from "@/components/site/Process";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

function App() {
  const [loading, setLoading] = useState(true);
  const lenisRef = useRef(null);

  useEffect(() => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      setLoading(false);
    };
    // If the page is already loaded (common), dismiss immediately.
    if (document.readyState === "complete") {
      finish();
    } else {
      window.addEventListener("load", finish);
    }
    // Safety fallbacks in case load event was missed.
    const t = setTimeout(finish, 2200);
    return () => {
      window.removeEventListener("load", finish);
      clearTimeout(t);
    };
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);


  const goContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App relative bg-ivory">
      <div className="noise-overlay" />
      <Loader hidden={!loading} />

      <ScrollProgress />
      <Navbar onBook={goContact} />

      <main>
        <Hero onBook={goContact} />
        <About />
        <EditorialMarquee />
        <Services />
        <WhyChooseUs />
        <Gallery />
        <Packages />
        <Process />
        <FAQ />
        <Contact />
      </main>

      <Footer />
      <FloatingButtons onInquiry={goContact} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
